import {
  dbui_v1_QueryHistogramRequest,
  dbuiV1QueryHistogramOptions,
} from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useQueries } from '@tanstack/react-query';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export type QueryHistogramRequest = {
  queryId: string;
  disabled?: boolean;
} & Omit<dbui_v1_QueryHistogramRequest, 'warehouse'>;

export const useGetQueryHistogram = (request: QueryHistogramRequest) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id;

  const { disabled, queryId, ...rest } = request;

  return useQuery({
    ...dbuiV1QueryHistogramOptions({
      ...defaultOptions(),
      path: { workspace, id: queryId! },
      body: {
        ...rest,
        warehouse,
      },
    }),
    enabled: !!queryId && !disabled,
  });
};

export const useGetQueriesHistogram = (requests: QueryHistogramRequest[]) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id;

  return useQueries({
    queries: requests.map((request) => {
      const { disabled, queryId, ...rest } = request;

      return {
        ...dbuiV1QueryHistogramOptions({
          ...defaultOptions(),
          path: { workspace, id: queryId! },
          body: {
            ...rest,
            warehouse,
          },
        }),
        enabled: !!queryId && !disabled,
      };
    }),
  });
};
